module.exports = __webpack_public_path__ + "img/intro_no.3d3e259b.svg";